export default {"src":"/_next/static/media/pink-school.41ed67f9.svg","height":18,"width":22,"blurWidth":0,"blurHeight":0};